import { useBeheerReleaseHighlights } from "@/entities/release-highlight";
import { DataTableSkeleton } from "@/shared/components";
import { ErrorDisplay } from "@/shared/components/error";
import { ReleaseHighlightsTabel } from "./release-highlights-tabel.tsx";

export function ReleaseHighlightsBeheer() {
    const { data: berichten, isPending, error } = useBeheerReleaseHighlights();

    return (
        <div className="flex flex-col gap-6 py-6">
            <div>
                <h1 className="text-xxl text-content-default font-bold">Release highlights</h1>
                <p className="text-s text-content-subtle mt-2">
                    Beheer de berichten onder het nieuwsicoon. Berichten met een publicatiedatum in de toekomst zie je alleen hier.
                </p>
            </div>

            {isPending && <DataTableSkeleton rowCount={6} columnCount={5} />}
            {error && <ErrorDisplay error={error} variant="section" title="Fout bij het laden van release hoogtepunten" />}
            {berichten && <ReleaseHighlightsTabel berichten={berichten} />}
        </div>
    );
}
